import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import { Box, Button, Alert, Snackbar } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import DynamicTablePercent from "./DynamicTablePercent";
import { validateLeadershipTable, validateTable } from "../../../../utils/validateTable";
import { restructureData } from "../../../../utils/restructureData";
import RegionTable from "./RegionTable";
import BusinessPartnerTable from "./BusinessPartnertable";
import DropDownTable from "./DropDowntable";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";

const GRI205_2 = ({ hide, downloadMode = false }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [formData, setFormData] = useState({
    alignmentWithExternal: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  const inputData = [
    {
      fieldName: "brokenDownByRegion",
      title:
        "a. How many members of the governance body have the organization's anti-corruption policies and procedures been communicated to, and what percentage does this represent, broken down by region?",
      fields: [
        {
          fieldName: "location",
          title: "Region of Operation",
          type: "text",
          placeholder: "Enter Text",
          width: "20%",
        },
        {
          fieldName: "goveranceBody",
          title: "Total Members of  Governance Body",
          type: "number",
          placeholder: "Enter Number",
          width: "20%",
        },
        {
          fieldName: "antiCorruption",
          title: "Members communicated about Anti-Corruption Policies ",
          type: "number",
          placeholder: "Enter Number",
          width: "24%",
        },
        {
          fieldName: "infored",
          title: "% Informed",
          type: "number",
          placeholder: "%",
          width: "16%",
        },
      ],
    },
  ];

  const inputData1 = [
    {
      title:
        "b. How many employees have the organization's anti-corruption policies and procedures been communicated to, and what percentage does this represent, broken down by employee category and region?",
      fields: [
        {
          fieldName: "employeeCategory",
          title: "Employee Category",
          type: "text",
          placeholder: "Type here",
          width: "20%",
        },
        {
          fieldName: "totalCategory",
          title: "Total No. of Employees in Category",
          type: "number",
          placeholder: "Enter Number",
          width: "20%",
        },
        {
          fieldName: "antiCorruptionPolicies",
          title: "No. of Employees Communicated about Anti-Corruption policies",
          type: "number",
          placeholder: "Enter Number",
          width: "22%",
        },
        {
          fieldName: "percentage",
          title: "% Employees Communicated",
          type: "number",
          placeholder: "%",
          width: "20%",
        },
      ],
    },
  ];

  const inputData2 = [
    {
      title:
        "c. How many business partners have the organization's anti-corruption policies and procedures been communicated to, and what percentage does this represent, broken down by business partner category and region?",
      fields: [
        {
          fieldName: "typeOfBusiness",
          title: "Type of Business Partner",
          type: "select",
          // options: ["Active", "Inactive"],
          options: [
            "Suppliers",
            "Agents",
            "Lobbyists",
            "Intermediaries",
            "Joint Venture Partners",
            "Consortia Partners",
            "Governments",
            "customers",
            "clients",
          ],
          placeholder: "Tap to select",
          width: "16%",
        },
        {
          fieldName: "totalBusinessPartners",
          title: "Total no. of Business partners",
          type: "number",
          placeholder: "Enter Number",
          width: "16%",
        },
        {
          fieldName: "noOfCategory",
          title:
            "No. of Business Partner Communicated about Anti-Corruption policies",
          type: "number",
          placeholder: "Enter Number",
          width: "16%",
        },

        {
          fieldName: "percentage",
          title: "% Business  Partner Informed",
          type: "number",
          placeholder: "%",
          width: "14%",
        },
        {
          fieldName: "antiCorruptionPolicies",
          title: "Additional Persons/ Organizations informed",
          type: "number",
          placeholder: "Enter Number",
          width: "14%",
        },
      ],
    },
  ];

  const [inputData3, setInputData3] = React.useState([
    {
      fieldName: "trainingGovernanceBodyAntiCorruption",
      title:
        "d. How many members of the governance body have received training on anti-corruption, and what percentage does this represent, broken down by region?",
      fields: [
        {
          fieldName: "region",
          title: "Region",
          // type: "select",
          // options: ["Active", "Inactive"], // Will be updated dynamically
          type: "text",
          placeholder: "Enter Text",
          width: "20%",
        },
        {
          fieldName: "totalGovernaceBody",
          title: "Total number of governance body members",
          type: "number",
          placeholder: "Enter Number",
          width: "20%",
        },
        {
          fieldName: "governaceBody",
          title: "Number of Governance Body Members Trained",
          type: "number",
          placeholder: "Enter Number",
          width: "20%",
        },
        {
          fieldName: "percentage",
          title: "% of Members Trained",
          type: "number",
          placeholder: "%",
          width: "20%",
        },
      ],
    },
  ]);

  const inputData4 = [
    {
      //   fieldName: "table",
      title:
        "e. How many employees have received training on anti-corruption, and what percentage does this represent, broken down by employee category and region?",
      fields: [
        {
          fieldName: "employeeCategory",
          title: "Employee Category",
          type: "text",
          placeholder: "Type here",
          width: "20%",
        },
        {
          fieldName: "totalCategory",
          title: "No. of Employees ",
          type: "number",
          placeholder: "Enter Number",
          width: "25%",
        },
        {
          fieldName: "antiCorruptionPolicies",
          title: "Employees Trained on Anti-Corruption",
          type: "number",
          placeholder: "Enter Number",
          width: "25%",
        },
        {
          fieldName: "percentage",
          title: "% of Employees Trained",
          type: "number",
          placeholder: "%",
          width: "20%",
        },
      ],
    },
  ];

  const initialStaticCategories = [
    "Board of Directors (BOD)",
    "KMP except BOD",
    "Other Employees",
    "Workers",
  ];

  const [tables, setTables] = React.useState(
    inputData.map((section) => ({ fieldName: section.fieldName, rows: [{}] }))
  );

  const [employeeTable, setEmployeeTable] = useState([
    {
      region: "",
      table: initialStaticCategories.map((category) => ({
        employeeCategory: category,
        totalCategory: "",
        antiCorruptionPolicies: "",
        percentage: "",
      })),
    },
  ]);

  const [tables4, setTables4] = useState([
    {
      region: "",
      table: initialStaticCategories.map((category) => ({
        employeeCategory: category,
        totalCategory: "",
        antiCorruptionPolicies: "",
        percentage: "",
      })),
    },
  ]);

  const [tables2, setTables2] = useState([
    {
      region: "",
      rows: [
        {
          typeOfBusiness: "",
          totalBusinessPartners: "",
          noOfCategory: "",
          antiCorruptionPolicies: "",
          percentage: "",
        },
      ],
    },
  ]);

  const [tables3, setTables3] = React.useState(
    inputData3.map((section) => ({ fieldName: section.fieldName, rows: [{}] }))
  );

  const [tabErrors, setTabErrors] = useState({});
  const [tabErrors1, setTabErrors1] = useState({});
  const [tabErrors2, setTabErrors2] = useState({});
  const [tabErrors3, setTabErrors3] = useState({});
  const [tabErrors4, setTabErrors4] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/gri/get?type=GRI200&Id=${id}`);
        if (response?.data?.data?.year < currentYear - 1) setDisabled(true);
        const data = response.data.data.GRI200 || {};

        // Extract regions from all datasets
        const regions1 = (data.representBrokenDownByEmployee || []).map(
          (item) => item.region || ""
        );
        const regions2 = (data.trainingEmployeesAntiCorruption || []).map(
          (item) => item.region || ""
        );
        const regions3 = (data.commAntiCorruptionPolicies || []).map(
          (item) => item.region || ""
        );

        // Merge and deduplicate regions
        const mergedRegions = [
          ...new Set([...regions1, ...regions2, ...regions3]),
        ];

        // Update inputData3 options dynamically
        setInputData3((prevInputData3) =>
          prevInputData3.map((section) => ({
            ...section,
            fields: section.fields.map((field) =>
              field.fieldName === "region"
                ? { ...field, options: mergedRegions }
                : field
            ),
          }))
        );

        // Ensure tables are set correctly
        setTables([
          {
            fieldName: "brokenDownByRegion",
            rows: data.brokenDownByRegion || [],
          },
        ]);

        setTables3([
          {
            fieldName: "trainingGovernanceBodyAntiCorruption",
            rows: data.trainingGovernanceBodyAntiCorruption || [],
          },
        ]);

        // Set employeeTable based on the response data
        const employeeData = data.representBrokenDownByEmployee || [];
        const transformedEmployeeData = employeeData.map((item) => ({
          region: item.region || "", // Set region or default to empty string
          table: item.table.map((category) => ({
            employeeCategory: category.employeeCategory || "",
            totalCategory: category.totalCategory || "",
            antiCorruptionPolicies: category.antiCorruptionPolicies || "",
            percentage: category.percentage || "",
          })),
        }));

        // Update employeeTable with the transformed data
        setEmployeeTable(transformedEmployeeData);

        // Set employeeTable based on the response data
        const tables4 = data.trainingEmployeesAntiCorruption || [];
        const transformedTables4 = tables4.map((item) => ({
          region: item.region || "", // Set region or default to empty string
          table: item.table.map((category) => ({
            employeeCategory: category.employeeCategory || "",
            totalCategory: category.totalCategory || "",
            antiCorruptionPolicies: category.antiCorruptionPolicies || "",
            percentage: category.percentage || "",
          })),
        }));

        // Update employeeTable with the transformed data
        setTables4(transformedTables4);

        // Set employeeTable based on the response data
        const tables2 = data.commAntiCorruptionPolicies || [];
        const transformedTables2 = tables2.map((item) => ({
          region: item.region || "", // Set region or default to empty string
          rows: item.rows.map((category) => ({
            typeOfBusiness: category.typeOfBusiness || "",
            totalBusinessPartners: category.totalBusinessPartners || "",
            antiCorruptionPolicies: category.antiCorruptionPolicies || "",
            percentage: category.percentage || "",
            noOfCategory: category.noOfCategory || "",
          })),
        }));

        console.log("TransformedTables2", transformedTables2);
        setTables2(transformedTables2);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    // console.log("fga", formData );
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const validateTableData = (tables, setError) => {
    const errors = {};

    tables.forEach((table, tableIndex) => {
      table.table.forEach((row, rowIndex) => {
        const rowErrors = {};

        // Check for empty fields
        ["totalCategory", "antiCorruptionPolicies", "percentage"].forEach(
          (field) => {
            if (!row[field]) rowErrors[field] = "This field is mandatory.";
          }
        );

        // Validate percentage
        if (row.percentage && (row.percentage < 0 || row.percentage > 100)) {
          rowErrors.percentage = "Percentage must be between 0 and 100.";
        }

        // Validate numbers
        ["totalCategory", "antiCorruptionPolicies"].forEach((field) => {
          if (row[field] && isNaN(row[field])) {
            rowErrors[field] = "Enter a valid number.";
          }
        });

        if (Object.keys(rowErrors).length > 0) {
          if (!errors[tableIndex]) errors[tableIndex] = {};
          errors[tableIndex][rowIndex] = rowErrors;
        }
      });
    });

    setError(errors);
    return Object.keys(errors).length === 0; // Return true if no errors
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // if (!validateForm()) return;  // Validate form before submission
      const isTableValid = validateLeadershipTable(inputData, tables, setTabErrors);
      const isTable3Valid = validateLeadershipTable(inputData3, tables3, setTabErrors3);

      const isEmployeeTableValid = validateLeadershipTable(
        inputData1,employeeTable,
        setTabErrors1,"","employeeCategory","percentage"
      );
      // const errors={...tabErrors2}
      const isTables2Valid = validateLeadershipTable(inputData2,tables2, setTabErrors2,"","percentage");
      // setTabErrors2({...errors,...tabErrors2})
      const isTables4Valid = validateLeadershipTable(inputData4,tables4, setTabErrors4,"","employeeCategory","percentage");

      if (
        !isEmployeeTableValid ||
        !isTables2Valid ||
        !isTables4Valid ||
        !isTableValid ||
        !isTable3Valid
      ) {
        return;
      }

      let transformedData = restructureData(tables);
      let transformedData3 = restructureData(tables3);
      let transformedTables2 = tables2.map(({ rows, ...rest }) => rest);

      const payload = {
        type: "GRI200",
        submitted205_2: true,
        //   antiCorruptionTrainingAndCommunication: {
        ...transformedData,
        ...transformedData3,
        representBrokenDownByEmployee: employeeTable,
        //   commAntiCorruptionPolicies: {
        //     ...tables2,
        //   },
        commAntiCorruptionPolicies: tables2,
        trainingEmployeesAntiCorruption: tables4,
        // },
      };

      try {
        await put(`/gri/update?Id=${id}`, payload);
        navigate(`/gri/economic-performance/205-3/${id}`);
      } catch (error) {
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/economic-performance/205-3/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {!hide && (
        <p className={styles.section_heading}>205 : Anti-corruption 2016</p>
      )}
      <p
        className={styles.main_heading}
        style={{ marginBottom: hide ? "-1rem" : "0" }}
      >
        205-2 : Communication and training about anti-corruption policies and
        procedures
      </p>

      {/* Section A */}

      <DynamicTablePercent
        inputData={inputData}
        tables={tables}
        setTables={setTables}
        errors={tabErrors}
        disabled={disabled}
        setErrors={setTabErrors}
        hide={hide}
        field1="infored"
      />

      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <RegionTable
        inputData={inputData1}
        tables={employeeTable}
        setTables={setEmployeeTable}
        errors={tabErrors1}
        disabled={disabled}
        setErrors={setTabErrors1}
        hide={hide}
        field1="percentage"
      />

      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <BusinessPartnerTable
        inputData={inputData2}
        tables={tables2}
        setTables={setTables2}
        errors={tabErrors2}
        disabled={disabled}
        setErrors={setTabErrors2}
        hide={hide}
        field1="percentage"
      />

      {/* {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>} */}
      <DropDownTable
        inputData={inputData3}
        tables={tables3}
        setTables={setTables3}
        errors={tabErrors3}
        disabled={disabled}
        setErrors={setTabErrors3}
        hide={hide}
        field1="percentage"
      />

      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <RegionTable
        inputData={inputData4}
        tables={tables4}
        setTables={setTables4}
        errors={tabErrors4}
        disabled={disabled}
        setErrors={setTabErrors4}
        hide={hide}
        field1="percentage"
      />

      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {/* Submit Button */}

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI205_2;
